export function addSpaceBeforeCaps(input: string): string {
  return input.replace(/([A-Z])/g, " $1").trim();
}

export function capitalizeFirstLetter(string: string): string {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function generateRandomString(length?: number): string {
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";

  const defaultLength = 16;
  const targetLength = length ?? defaultLength;

  for (let i = 0; i < targetLength; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    result += characters.charAt(randomIndex);
  }

  return result;
}

export function camelCaseToDisplayString(input: string | undefined): string {
  if (!input) {
    return "";
  }

  return input
    .replace(/([A-Z])/g, " $1")
    .replace(/^./, function (str) {
      return str.toUpperCase();
    })
    .trim();
}

export function displayStringToCamelCase(input: string | undefined): string {
  if (!input) {
    return "";
  }

  const withoutSpaces = input.replace(/\s/g, "");

  const camelCase = withoutSpaces.charAt(0).toLowerCase() + withoutSpaces.slice(1);

  return camelCase.trim();
}
